<template>
    <div />
</template>

<script lang="ts" setup>
definePageMeta({
    middleware: "redirect-to-external-app",
})
</script>

<style scoped></style>
